// @flow

import EventEmitter from 'eventemitter3';

const CommonData = {
  // Create a backbone model and turn it into a Data object
  backboneModelAsData({
    testModelExists,
    createModel,
    model,
    modelToData,
    fetchOptions = {},
  }: any) {
    const emitter = new EventEmitter();

    let isListening = false;

    const listen = () => {
      if (isListening) {
        return;
      }
      isListening = true;
      model().on('change', newModel => {
        emitter.emit('change', modelToData(newModel));
      });
      model().on('sync error', () => {
        emitter.emit('change', modelToData(model()));
      });
    };

    const Data = {
      // Return only the currently loaded data.
      loaded() {
        if (testModelExists()) {
          return modelToData(model());
        }
        return {};
      },

      // Listen to changes in data.
      on(type: string, cb: Function) {
        if (!testModelExists()) {
          createModel();
          model().fetch(fetchOptions);
        }
        listen();
        emitter.on.call(emitter, type, cb);
      },

      off: emitter.off.bind(emitter),

      removeAllListeners() {
        emitter.removeAllListeners();
      },
    };

    return Data;
  },
};

export default CommonData;
